import styled from "styled-components";

type Props = {
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  textAlign?: string;
  fontSize?: string;
};
export const Headline = styled.h1<Props>`
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => props.fontSize || "48px;"};
  line-height: 62px;

  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  text-align: ${(props) => props.textAlign || "left"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  margin-right: ${(props) => props.marginRight || "0px"};
  color: #170f49;
`;

export const PreText = styled.h4`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;

  text-align: center;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  margin-bottom: 0;
`;

export const Paragraph = styled.p<Props>`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  text-align: ${(props) => props.textAlign || "left"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  margin-right: ${(props) => props.marginRight || "0px"};
  color: #6f6c90;
`;

export const ErrorText = styled.span<Props>`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  text-align: ${(props) => props.textAlign || "left"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  margin-right: ${(props) => props.marginRight || "0px"};
  color: ${(props) => props.theme.colors.error};
`;
